import { scopedTranslation } from '@utils/I18n'

import { AddShiftsDocument, type ShiftInput } from '@frontend/graphql/mutations/addShifts.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

const t = scopedTranslation('author_shifts')

type AddShiftsArgs = {
  eventId: string
  shifts: ShiftInput[]
  onSuccess: () => void
  onError?: () => void
}

export const useAddShiftsMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: AddShiftsDocument,
    succeeded: (response) => Boolean(response?.addShifts?.success),
    errorCode: 'ADD_SHIFTS_ERROR',
    failureMessage: t('errors.add_failed'),
    extractErrors: (response) => response?.addShifts?.errors,
  })

  return {
    addShifts: ({ eventId, shifts, onSuccess, onError }: AddShiftsArgs) => run({ eventId, shifts, onSuccess, onError }),
    isPending,
  }
}
